import React, { useEffect, useState } from "react"
import { Card, CardBody, CardFooter, Col, Row } from "reactstrap"
import { connect } from "react-redux"
import { SaveButton } from "components/Buttons"
import {
  FeatureNameTicks,
  getFeatureDisplayName,
  getMostActiveFeature,
  getTop5ActiveFeature,
} from "../utils"
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

const FeatureUsageCard = ({ handleViewMore, featureUsageReport }) => {
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    if (featureUsageReport) {
      setChartData(getTop5ActiveFeature(featureUsageReport))
    }
  }, [featureUsageReport])

  return (
    <Card className="mini-stats-wid flex-grow-1">
      <CardBody>
        <Row>
          <Col>
            <span className="h5">Feature Usage </span>
            <span className="text-muted fw-medium">(# of views)</span>
          </Col>
        </Row>
        <Row style={{ height: "210px" }}>
          <Col>
            {chartData && chartData.length > 0 ? (
              <ResponsiveContainer>
                <BarChart
                  data={chartData}
                  layout="vertical"
                  width={500}
                  height={300}
                  margin={{
                    top: 20,
                    right: 5,
                    left: 35,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis type="number" />
                  <YAxis
                    type="category"
                    dataKey="name"
                    interval={0}
                    tick={<FeatureNameTicks fontSize={10} />}
                  />
                  <Tooltip cursor={{ fill: "rgb(220, 220, 220, 0.5)" }} />
                  <Bar
                    dataKey="views"
                    name="Views"
                    fill="#8884d8"
                    barSize={20}
                  />
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <p>No data to display</p>
            )}
          </Col>
        </Row>
      </CardBody>
      {!!chartData && chartData.length > 0 && (
        <CardFooter style={{ background: "white" }} className="pt-0">
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color={"primary"}
                size="sm"
                content="View More"
                onClick={handleViewMore}
              />
            </Col>
          </Row>
        </CardFooter>
      )}
    </Card>
  )
}

const mapStateToProps = state => ({
  featureUsageReport: state.Analytics.featureUsageReport,
})

export default connect(mapStateToProps)(FeatureUsageCard)
